import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Field, reduxForm, getFormValues } from 'redux-form';

import Button from '../../../shared/button/components/button';
import PageHeader from '../../../shared/page-header/components/page-header';
import RenderIf from '../../../shared/render-if/components/render-if';
import CloseBtn from '../../../shared/close-btn/components/close-btn';
import EmptyState from '../../../shared/empty-state/components/empty-state';
import DefaultSelect from '../../../shared/default-select/components/default-select';
import Helpers from '../../../../common/helpers';
import constants from '../../../../common/constants';
import bannersConstants from '../constants/banners-constants';
import { toggleBannerCodeModal } from '../actions/banners-actions';
import { toggleInfoModal } from '../../../shared/info-modal/actions/info-modal-actions';
import { toggleChooseCampaignModal } from '../../campaigns/actions/campaigns-actions';

import '../styles/banner-code-modal.css';

class BannerCodeModal extends Component {
  state = {
    html: null,
  };

  componentDidMount() {
    const { type, campaigns, banner, profile, change, video } = this.props;

    if (!campaigns || campaigns.length === 0) {
      return;
    }

    const campaign = campaigns[0] || {};

    const url = this.getUrl(campaign, profile, 'en');

    this.setHtmlCode(url, type, banner, video);
    change('campaign', campaigns[0].reference_code_id);
    change('language', 'en');
  }

  getUrl(campaign, profile, language) {
    const { sites, reason } = this.props;
    const username = profile && profile.user_name ? profile.user_name : '';
    let url = '';

    if (campaign) {
      const link = _.find(sites, { page_code: campaign.link_url });
      url = link
        ? Helpers.formUrl(
            link,
            {
              reason: username || reason,
              refcode: campaign.partner_code,
              code: campaign.partner_code,
            },
            language
          )
        : '';
    }

    return url;
  }

  setHtmlCode(url, type, banner, videoUrl) {
    let html = type === constants.generate_code_types.banner ? Helpers.getBannerHtml(url, banner) : Helpers.getVideoUrl(url, videoUrl);

    this.setState({ html });
  }

  closeModal() {
    const { toggleBannerCodeModal } = this.props;

    toggleBannerCodeModal(false, null, null);
  }

  openChooseCampaignModal() {
    const { toggleChooseCampaignModal } = this.props;

    toggleChooseCampaignModal(true);
  }

  copyToClipboard(bannerHtml) {
    const { toggleInfoModal } = this.props;

    this.closeModal();
    Helpers.copyToClipboard(bannerHtml);
    toggleInfoModal(true, constants.info_modal_types.success.value, 'DASHBOARD.COPY_BANNER_CODE_MESSAGE');
  }

  handleDropdownChange(event) {
    const { campaigns, profile, banner, type, formValues } = this.props;
    const campaign = _.find(campaigns, item => {
      return item.reference_code_id.toString() === event.target.value.toString();
    });
    const url = this.getUrl(campaign, profile, formValues.language);

    this.setHtmlCode(url, type, banner);
  }

  handleLanguageChange(event) {
    const { formValues, campaigns, banner, type, profile } = this.props;
    const campaign = _.find(campaigns, item => {
      return item && item.reference_code_id.toString() === formValues.campaign.toString();
    });
    const url = this.getUrl(campaign, profile, event.target.value);

    this.setHtmlCode(url, type, banner);
  }

  render() {
    const { showBannerCodeModal, campaigns } = this.props;
    const { html } = this.state;

    return (
      <Modal visible={showBannerCodeModal} effect="fadeInUp" onClickAway={() => this.closeModal()}>
        <div className="banner-code-modal">
          <CloseBtn callback={this.closeModal.bind(this)} />
          <RenderIf if={campaigns && campaigns.length > 0}>
            <div className="banner-code-modal__wrapper">
              <PageHeader title={'BANNERS.YOUR_BANNER_CODE'} />
              <div className="row">
                <form noValidate>
                  <div className="col-md-12 m-t-20">
                    <Field
                      name={'campaign'}
                      inputName={'campaign'}
                      label={'BANNERS.SELECT_CAMPAIGN'}
                      options={campaigns}
                      optionLabel={'link_name'}
                      customLabel={'CAMPAIGNS.MOBILE_TRAFFIC'}
                      optionValue={'reference_code_id'}
                      component={DefaultSelect}
                      onChange={e => this.handleDropdownChange(e)}
                    />
                  </div>
                  <div className="col-md-12 m-t-20">
                    <Field
                      name={'language'}
                      inputName={'language'}
                      label={'HEADER.LANGUAGE_DROPDOWN_LABEL'}
                      options={bannersConstants.banner_languages}
                      optionLabel={'text'}
                      optionValue={'value'}
                      component={DefaultSelect}
                      onChange={e => this.handleLanguageChange(e)}
                    />
                  </div>
                </form>
              </div>
              <pre className="m-t-20">
                <code>{html}</code>
              </pre>
              <div className="row">
                <div className="col-sm-6 col-xs-12">
                  <Button label={'COMMON.COPY'} customClass={`affiliate-btn-red m-t-20`} onClick={() => this.copyToClipboard(html)} />
                </div>
                <div className="col-sm-6 col-xs-12">
                  <Button label={'COMMON.CLOSE'} customClass={`m-t-20`} onClick={() => this.closeModal()} />
                </div>
              </div>
            </div>
          </RenderIf>
          <RenderIf if={campaigns && campaigns.length === 0}>
            <EmptyState
              title={'CAMPAIGNS.NO_CAMPAIGNS_MESSAGE'}
              actionButtonLabel={'CAMPAIGNS.CREATE_FIRST_CAMPAIGN'}
              callback={this.openChooseCampaignModal.bind(this)}
              secondAction={this.closeModal.bind(this)}
            />
          </RenderIf>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  showBannerCodeModal: state.bannersReducer.showBannerCodeModal,
  type: state.bannersReducer.type,
  banner: state.bannersReducer.banner,
  video: state.bannersReducer.video,
  campaigns: state.campaignsReducer.campaigns,
  sites: state.linkCreatorReducer.sites,
  formValues: getFormValues(bannersConstants.campaign_selector_form)(state),
});

const mapDispatchToProps = dispatch => ({
  toggleBannerCodeModal: (show, type, banner, video) => {
    dispatch(toggleBannerCodeModal(show, type, banner, video));
  },
  toggleInfoModal: (show, type, message, translations, callback, path, btnText) => {
    dispatch(toggleInfoModal(show, type, message, translations, callback, path, btnText));
  },
  toggleChooseCampaignModal: show => {
    dispatch(toggleChooseCampaignModal(show));
  },
});

BannerCodeModal = reduxForm({
  form: bannersConstants.campaign_selector_form,
})(BannerCodeModal);

export default connect(mapStateToProps, mapDispatchToProps)(BannerCodeModal);



// WEBPACK FOOTER //
// ./src/app/main/banners/components/banner-code-modal.js